import { Injectable, inject } from "@angular/core";
import {
  AgentParam,
  AppConfigService,
  IInteraction,
  UserService,
} from "../../core-ui";
import { InteractionService } from "./interaction.service";
import { PureCloudService } from "./purecloud.service";
import {
  GENESYS_WORKFLOW_ADDRESS,
  GENESYS_WORKFLOW_AGENT_ID,
  GENESYS_WORKFLOW_AGENT_PARTICIPANT_ID,
  GENESYS_WORKFLOW_CONVERSATION_ID,
  GENESYS_WORKFLOW_MESSAGE,
} from "../app.enums";
import {
  GenesysInteraction,
  IGenesysWorkflowExecuteRequest,
  Interaction,
} from "../models";

@Injectable({ providedIn: "root" })
export class SmsService {
  private config = inject(AppConfigService);
  private genesys = inject(PureCloudService);
  private user = inject(UserService);
  private interactionService = inject(InteractionService);

  async sendUsingWorkflow(params: {
    flowId: string;
    interaction: GenesysInteraction;
    phoneNumber: string;
    link: string;
  }): Promise<void> {
    const request: IGenesysWorkflowExecuteRequest = {
      flowId: params.flowId,
      inputData: {
        [GENESYS_WORKFLOW_AGENT_ID]: this.user.getActiveUser().getId(),
        [GENESYS_WORKFLOW_AGENT_PARTICIPANT_ID]:
          params.interaction.getAgentId?.() ||
          this.user.getActiveUser().getId(),
        [GENESYS_WORKFLOW_CONVERSATION_ID]: params.interaction.getId(),
        [GENESYS_WORKFLOW_ADDRESS]: params.phoneNumber,
        [GENESYS_WORKFLOW_MESSAGE]: this.resolveSmsMessage(
          params.interaction.getCustomerLink(params.link)
        ),
      },
    };
    await this.genesys.executeWorkflow(request);
  }

  async sendUsingQueue(params: {
    queueId: string;
    interaction: IInteraction;
    phoneNumber: string;
    link: string;
  }): Promise<void> {
    const interaction = await this.interactionService.createSMSInteraction(
      params.queueId,
      params.phoneNumber
    );
    const tmpInteraction = new Interaction(interaction.id);
    await this.interactionService.postMessageToInteraction(
      tmpInteraction,
      this.resolveSmsMessage(params.interaction.getCustomerLink(params.link)),
      { type: "sms" }
    );
  }

  private resolveSmsMessage(customerLink: string): string {
    const template = this.config.agentParam(
      AgentParam.SMS_CUSTOM_MESSAGE
    ) as string;
    if (!template) return customerLink;
    return template.replace(/{{link}}/g, customerLink);
  }
}
